import React from 'react';

import { Box, Icon } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';

export const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { formatMessage } = useIntl();

  return (
    <Box margin="2rem 0 1rem">
      <ActionButton
        size={ActionButtonSizes.SMALL}
        variant={ActionButtonVariants.OUTLINE}
        onClick={onClick}
        startIcon={<Icon icon="arrowLeft" color="primary" />}
      >
        {formatMessage(messages.mainMenu)}
      </ActionButton>
    </Box>
  );
};
const messages = defineMessages({
  mainMenu: {
    id: 'mainMenu',
    defaultMessage: 'Main menu',
    description: 'No description',
  },
});
